import React from 'react';
import { AutocompleteProps } from '@mui/material';

import Complete from './complete';
import Simplified from './simplified';
import * as enums from '../../enums';
import { resourcesSearch } from '../../helpers';
import { mui } from '../../libs';
import * as types from '../../types';

export type CustomOption = { id?: number; name?: string; handle?: string; [key: string]: any };

export type ValueType<Multiple, ChooseHandle> = ChooseHandle extends false | undefined
  ? Multiple extends false | undefined
    ? number
    : number[]
  : Multiple extends false | undefined
    ? string
    : string[];

export interface IResourceAutocompleteProps<T, Multiple extends boolean, ChooseHandle> {
  value: ValueType<Multiple, ChooseHandle>;
  setValue: (_v: ValueType<Multiple, ChooseHandle>) => void;
  type: enums.RESOURCES_TYPES_ENUM | 'sp_pipeline' | 'signal_based' | 'alpha_model';
  showValid?: boolean;
  autocompleteProps?: Partial<AutocompleteProps<any, boolean, boolean, boolean>>;
  inputProps?: React.ComponentProps<typeof mui.core.TextField>;
  disabled?: boolean;
  enableNone?: boolean;
  chooseHandle?: boolean;
  showFilters?: boolean;
  sortBy?: any[];
  groupBy?: (_v: T) => string;
  filter?: (_v: T) => boolean;
  getOptionDisabled?: (_v: T) => boolean;
  skipWorkspaceCheck?: boolean;
  hideDescription?: boolean;
  customInputFilters?: types.guidedSearch.Filter[];
  customWidth?: number;
  noneLabel?: string;
  getOptionLabel?: (_option: T) => string;
  customOptions?: CustomOption[];
}

const ResourceAutocomplete = <
  T extends resourcesSearch.ReturnItem = types.common.ResourceExpanded,
  Multiple extends boolean | undefined = undefined,
  ChooseHandle extends boolean | undefined = undefined,
>(
  props: IResourceAutocompleteProps<T, Multiple, ChooseHandle>
) => {
  const { customOptions } = props;

  if (customOptions) {
    return <Simplified<T, Multiple, ChooseHandle> {...props} />;
  }

  return <Complete<T, Multiple, ChooseHandle> {...props} />;
};

export default ResourceAutocomplete;
